import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Noticia } from "@src/app/models/interfaces/noticia.interface";
import { DetalleNoticiasService } from "@src/app/servicios/detalle-noticias/detalle-noticias.service";
import { Subscription, firstValueFrom } from "rxjs";
import { ConfigService } from "src/app/servicios/config/config.service";
import { KebabCasePipe } from "../../pipes/kebab-case.pipe";
import { SeoService } from "../../servicios/seo/seo.service";
import { FooterService } from "@src/app/servicios/footer.service";

@Component({
  selector: "app-carta-director",
  templateUrl: "./carta-director.component.html",
  styleUrls: ["./carta-director.component.css"],
  standalone: true,
  providers: [DetalleNoticiasService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartaDirectorComponent implements OnInit, OnDestroy {
  // Variable que almacena la noticia obtenida
  noticia: Noticia;
  // Constantes globales de la aplicación
  constantesGlobales: any;
  // URL generada para la noticia
  urlNoticia;
  // Suscripción a los parámetros de la ruta
  rSub: Subscription;

  constructor(
    private detalleNoticiasService: DetalleNoticiasService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly configService: ConfigService,
    private readonly seoService: SeoService,
    private readonly kebabPipe: KebabCasePipe,
    private readonly cdr: ChangeDetectorRef,
    private readonly footerService: FooterService,
  ) {}

  /**
   * Inicializa el componente:
   * - Obtiene constantes globales.
   * - Se suscribe a la ruta para obtener la noticia.
   * - Genera la URL de la noticia y actualiza los meta tags SEO.
   */
  ngOnInit(): void {
    this.footerService.isPaginationFinished.set(true);
    this.constantesGlobales = this.configService.getConstantesGlobales();
    this.rSub = this.activatedRoute.params.subscribe((parms: any) => {
      if (parms.id2) {
        const video = this.detalleNoticiasService.getVideo(this.constantesGlobales.idAmbito, parms.id2);
        if (video) {
          firstValueFrom(video).then((result) => {
            if (!result) return;
            const slug = this.kebabPipe.transform(result?.tituloSeo);
            const idVideo = result.idVideo;
            this.urlNoticia = this.constantesGlobales.siteDomain + "/linea-editorial/carta-del-director/" + idVideo + "/" + slug;
            result.urlCanonica = this.urlNoticia;
            result.urlNoticia = this.urlNoticia;
            this.noticia = result;
            this.cdr.detectChanges();
            this.seoService.updateMetaTags(this.noticia);
          });
        }
      }
    });
  }

  /**
   * Se ejecuta al destruir el componente.
   * Cancela la suscripción para evitar fugas de memoria.
   */
  ngOnDestroy(): void {
    if (this.rSub) {
      this.rSub.unsubscribe();
    }
  }
}
